import { useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";

const FONT = "'Manrope', sans-serif";
const inputStyle = { fontFamily: FONT, background: "#0A0A0F", border: "1px solid #1A1A22", borderRadius: "4px", color: "#fff", caretColor: "#A855F7" };
const labelStyle = { fontFamily: FONT, fontSize: "11px", fontWeight: 600, color: "#555", letterSpacing: "0.08em", textTransform: "uppercase" };

// Bundle S-1: second step of sign-in. Accepts a 6-digit authenticator code or a recovery code.
export function TwoFactorStep({ onVerify, onCancel, submitting, error }) {
  const [code, setCode] = useState("");
  const [useRecovery, setUseRecovery] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    onVerify(code.trim());
  };

  const toggle = () => { setUseRecovery((v) => !v); setCode(""); };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="twofa-form">
      <div className="flex items-center gap-2" style={{ color: "#888", fontFamily: FONT, fontSize: "13px" }}>
        <ShieldCheck className="h-4 w-4" style={{ color: "#A855F7" }} />
        {useRecovery ? "Enter one of your recovery codes." : "Enter the 6-digit code from your authenticator app."}
      </div>
      <div>
        <label className="block mb-1.5" style={labelStyle}>{useRecovery ? "Recovery code" : "Authentication code"}</label>
        <input
          type="text" value={code} autoFocus autoComplete="one-time-code"
          inputMode={useRecovery ? "text" : "numeric"} pattern={useRecovery ? undefined : "[0-9 ]*"} maxLength={useRecovery ? 11 : 7}
          onChange={(e) => setCode(useRecovery ? e.target.value : e.target.value.replace(/[^0-9 ]/g, ""))}
          className="w-full px-3.5 py-2.5 text-sm outline-none transition-all mmntm-input tracking-[0.3em]"
          style={inputStyle} placeholder={useRecovery ? "xxxxx-xxxxx" : "000000"} required data-testid="twofa-code-input" />
      </div>
      {error && (
        <div className="px-3.5 py-2.5 text-sm" style={{ fontFamily: FONT, background: "#DC262610", color: "#F87171", border: "1px solid #DC262625", borderRadius: "4px" }}
          data-testid="twofa-error">{error}</div>
      )}
      <button type="submit" disabled={submitting || !code.trim()}
        className="w-full py-2.5 text-sm font-semibold transition-all disabled:opacity-50"
        style={{ fontFamily: FONT, background: "#A855F7", color: "#fff", borderRadius: "4px" }} data-testid="twofa-submit-btn">
        {submitting ? "Checking…" : "Verify"}
      </button>
      <div className="flex items-center justify-between text-xs" style={{ fontFamily: FONT, color: "#555" }}>
        <button type="button" onClick={toggle} className="flex items-center gap-1 hover:underline" data-testid="twofa-toggle-recovery">
          <KeyRound className="h-3 w-3" /> {useRecovery ? "Use authenticator code" : "Use a recovery code"}
        </button>
        <button type="button" onClick={onCancel} className="hover:underline" data-testid="twofa-cancel-btn">Back to sign in</button>
      </div>
    </form>
  );
}
